import { PUBLIC_TYPESENSE_URL, PUBLIC_TYPESENSE_API_KEY } from '$env/static/public';
import { ApiClientError } from '$lib/api/util/errorInterceptor';

export type TypesenseParams = {
    q: string;
    query_by: string;
    prefix?: string;
    infix?: string;
    pre_segmented_query?: string;
    preset?: string;
    vector_query?: string;
    voice_query?: string;
};

export function createTypesenseApiClient(config: { baseURL: string; accessToken: string }) {
    async function invoke(
        route: string,
        params: TypesenseParams,
        { returnRawResponse }: { returnRawResponse?: boolean }
    ) {
        let response: Response | undefined;

        try {
            response = await fetch(
                config.baseURL + route + (params ? '?' + new URLSearchParams(Object.entries(params)).toString() : ''),
                {
                    method: 'GET',
                    headers: new Headers({
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'x-typesense-api-key': config.accessToken
                    } as Record<string, string>)
                }
            );
        } catch (error) {
            console.log('Failed Typesense request: ', error);
            throw new ApiClientError();
        }

        if (returnRawResponse) {
            return response as any;
        }

        let data: any;

        try {
            data = await response.json();
        } catch (error) {
            console.log('Failed Data conversion to JSON: ', error);
            throw new ApiClientError();
        }

        if (!response?.ok) {
            throw new ApiClientError(response, data);
        }

        return data;
    }

    return { invoke };
}

export const typesenseApiClient = createTypesenseApiClient({
    baseURL: PUBLIC_TYPESENSE_URL,
    accessToken: PUBLIC_TYPESENSE_API_KEY
});
